import * as Sentry from "@sentry/react";
import "proxy-polyfill";
import { ensureNotNull } from "@CommonLib/src/utils/type_guards";
import App from "@Src/App";
import * as React from "react";
import { createRoot } from "react-dom/client";

Sentry.init({
	dsn: "https://a0d4239ac6273e82480ddee9edeaa409@o31292.ingest.us.sentry.io/4511152197861376",
	release: "static",
	environment: import.meta.env["VITE_ENVIRONMENT"],
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	integrations: [Sentry.replayIntegration()],
	replaysSessionSampleRate: 1.0,
	replaysOnErrorSampleRate: 1.0,
});

const container = ensureNotNull(
	document.getElementById("root"),
	"should not be null",
);

const root = createRoot(container);

root.render(
	<React.StrictMode>
		<Sentry.ErrorBoundary>
			<App />
		</Sentry.ErrorBoundary>
	</React.StrictMode>,
);
